import { relativeLuminance, type RGB } from './color';

/**
 * WCAG 2.1 对比度
 * https://www.w3.org/TR/WCAG21/#dfn-contrast-ratio
 */
export function contrastRatio(a: RGB, b: RGB): number {
  const la = relativeLuminance(a);
  const lb = relativeLuminance(b);
  const [light, dark] = la >= lb ? [la, lb] : [lb, la];
  return (light + 0.05) / (dark + 0.05);
}

export interface WcagResult {
  ratio: number;
  AA_normal: boolean; // 4.5
  AA_large: boolean; // 3.0
  AAA_normal: boolean; // 7.0
  AAA_large: boolean; // 4.5
}

export function wcag(a: RGB, b: RGB): WcagResult {
  const ratio = contrastRatio(a, b);
  return {
    ratio,
    AA_normal: ratio >= 4.5,
    AA_large: ratio >= 3,
    AAA_normal: ratio >= 7,
    AAA_large: ratio >= 4.5
  };
}
